import KNAttribute from 'components/KNAttribute/KNAttribute'
import { type ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { LegData } from './TripDetails.types'

export interface AssetIdAttributeProps {
  leg: LegData
  stopType: 'PUP' | 'DEL' | 'CUS'
}

const AssetIdAttribute = ({
  leg,
  stopType,
}: AssetIdAttributeProps): ReactNode => {
  const { t } = useTranslation()
  const [assetId, setAssetId] = useState<string>()

  useEffect(() => {
    setAssetId(
      leg.wayPoints.find((stop) => stop.type === stopType)?.references?.find((reference) => reference.code === 'HAS')?.value
    )
  }, [leg, stopType])

  if (!assetId) {
    return null
  }

  return (
    <KNAttribute
      label={t('screens.cs.trip_details.card.asset_id')}
      value={assetId}
      size="medium"
      hideEmpty
    />
  )
}

export default AssetIdAttribute
